import sizes from 'modules/application-link/domain/constants/sizes';
import UDText from 'ud-ui/components/text';
import useMediaQuery from 'shared/hooks/use-media-query';
import Layout from '../components/layout';

const ApplicationSuccessPage: React.FC = () => {
  const isMobile = useMediaQuery(`(max-width: ${sizes.mobile.WIDTH}px)`);

  return (
    <Layout>
      <UDText
        id="title"
        type="title-1"
        style={{
          fontWeight: 700,
          textAlign: 'center',
          fontSize: isMobile ? 24 : 36,
          marginTop: 26,
          maxWidth: isMobile ? 309 : 630,
          lineHeight: 'unset',
        }}
        color="white"
      >
        Онлайн заявка на участие в турнире успешно отправлена!
      </UDText>
      <div
        style={{
          fontSize: '124px',
          width: 124,
          height: 124,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: isMobile ? 28 : 24,
        }}
      >
        🙌
      </div>
    </Layout>
  );
};

export default ApplicationSuccessPage;
